import { UsersAction, UsersActionType } from "../actions/users";
import { IUserLoginInfo } from "../../api/entities/account";

export interface IUsersState {
  loading: boolean;
  error: string;
  currentUser: IUserLoginInfo;
  sessionExpired: boolean;
}

export const USERS_DEFAULT_STATE: IUsersState = {
  loading: false,
  error: "",
  currentUser: null,
  sessionExpired: false,
};

export default function users(
  state = USERS_DEFAULT_STATE,
  action: UsersAction
): IUsersState {
  switch (action.type) {
    case UsersActionType.FetchCurrentUser:
      return {
        ...state,
        currentUser: action.user,
        sessionExpired: false,
      };
    case UsersActionType.UserLoggedIn:
      return {
        ...state,
        currentUser: { ...state.currentUser, ...action.loginInfo },
        sessionExpired: false,
      };
    case UsersActionType.SessionExpired:
      return {
        ...state,
        currentUser: null,
        sessionExpired: true,
      };
    default:
      return state;
  }
}
